import LabServiceModel from "@/models/LabServiceModel";

export default class ManagedListKinModel extends LabServiceModel {
  modelName() {
    return "kin";
  }
  defaults() {
    return {
      id: null,
      parent_id: null,
      type: null,
      sub_type: null,
      list: null,
      description: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    };
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      parent_id: val => this.nullStringMutator(val),
      type: val => this.nullStringMutator(val),
      sub_type: val => this.nullStringMutator(val),
      list: val => this.nullStringMutator(val),
      description: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val)
    };
  }
  validation() {
    return {};
  }
}
